/* FROSTLINE interactions — load with defer:
   <script src="{{ 'frostline.js' | asset_url }}" defer></script> */
(function(){
  /* ---- ambient snow (targets .frost-bg canvas if present) ---- */
  var c=document.querySelector('.frost-bg canvas');
  if(c && !window.matchMedia('(prefers-reduced-motion:reduce)').matches){
    var x=c.getContext('2d'), w,h,flakes;
    function size(){ w=c.width=innerWidth; h=c.height=innerHeight;
      flakes=Array.from({length:70},function(){return{x:Math.random()*w,y:Math.random()*h,r:Math.random()*1.8+.4,s:Math.random()*.4+.15,d:Math.random()*6};}); }
    size(); addEventListener('resize',size);
    (function loop(){ x.clearRect(0,0,w,h);
      flakes.forEach(function(f){ x.beginPath(); x.arc(f.x,f.y,f.r,0,7); x.fillStyle='rgba(200,225,245,'+(f.r/2.4)+')'; x.fill();
        f.y+=f.s; f.x+=Math.sin((f.y+f.d)/40)*.3; if(f.y>h){f.y=-4; f.x=Math.random()*w;} });
      requestAnimationFrame(loop); })();
  }

  /* ---- hero carousel ---- */
  document.querySelectorAll('[data-frost-carousel]').forEach(function(root){
    var track=root.querySelector('.frost-track'), slides=track.children, dots=root.querySelector('.frost-dots');
    var N=slides.length, idx=0, timer;
    for(var i=0;i<N;i++){ var d=document.createElement('button'); if(i===0)d.className='on';
      (function(j){ d.onclick=function(){ go(j); reset(); }; })(i); dots.appendChild(d); }
    function go(i){ idx=(i+N)%N; track.style.transform='translateX(-'+(idx*100)+'%)';
      [].forEach.call(dots.children,function(dd,j){ dd.classList.toggle('on',j===idx); }); }
    function auto(){ timer=setInterval(function(){go(idx+1);},6000); } function reset(){ clearInterval(timer); auto(); }
    var nx=root.querySelector('.frost-scroll.right'), pv=root.querySelector('.frost-scroll.left');
    if(nx)nx.onclick=function(){go(idx+1);reset();}; if(pv)pv.onclick=function(){go(idx-1);reset();};
    auto();
  });

  /* ---- interactive card tilt + flip ---- */
  document.querySelectorAll('.frost-tcard').forEach(function(card){
    var glare=card.querySelector('.glare'), flipped=false;
    card.addEventListener('pointermove',function(e){ if(flipped)return;
      var r=card.getBoundingClientRect(), px=(e.clientX-r.left)/r.width, py=(e.clientY-r.top)/r.height;
      card.style.transform='rotateX('+((0.5-py)*16)+'deg) rotateY('+((px-0.5)*20)+'deg)';
      if(glare){ glare.style.setProperty('--gx',px*100+'%'); glare.style.setProperty('--gy',py*100+'%'); glare.style.opacity='.9'; }
    });
    card.addEventListener('pointerleave',function(){ if(!flipped)card.style.transform='rotateX(0) rotateY(0)'; if(glare)glare.style.opacity='0'; });
    var fb=card.parentNode.parentNode.querySelector('[data-frost-flip]');
    if(fb)fb.onclick=function(){ flipped=!flipped; card.style.transform=flipped?'rotateY(180deg)':'rotateX(0) rotateY(0)'; if(glare)glare.style.opacity='0'; };
  });

  /* ---- rare card overlay flow ---- */
  var overlay=document.querySelector('.frost-rare');
  if(overlay){
        // lock the page scroll while the rare overlay is open
    new MutationObserver(function(){
      var isOpen = overlay.classList.contains('show');
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      document.body.style.overflow = isOpen ? 'hidden' : '';
    }).observe(overlay, { attributes:true, attributeFilter:['class'] });
    var rcard=overlay.querySelector('.card'),
        center=overlay.querySelector('.center'),
        vid=overlay.querySelector('video');

    function open(){ overlay.classList.add('show'); rcard.classList.remove('playing'); center.style.display='grid'; }

    // click play → video + audio together, with controls
    function play(){
      rcard.classList.add('playing');
      center.style.display='none';
      if(vid){
        vid.muted=false;
        vid.controls=true;
        vid.play().catch(function(){ vid.muted=true; vid.play(); });
      }
    }

    document.querySelectorAll('[data-frost-open-rare]').forEach(function(b){
      b.onclick=function(e){ e.preventDefault(); open(); };
    });
    overlay.querySelector('.close').onclick=function(){ overlay.classList.remove('show'); if(vid){ vid.pause(); } };
    if(center) center.onclick=play;

    // rare cards flagged autoplay: open the overlay on load (still waits for the play button)
    if(overlay.getAttribute('data-autoplay')==='1'){ open(); }
  }
})();
